module.exports = __webpack_public_path__ + "static/media/tpn-ce-wire-4.d1f7dd5a.png";